export const env = {
  server_url: "http://",
  prod: false,
  qiniu_domain: "",
  wx_app_id: "",
  wx_msg_template_id: "",
};



// WEBPACK FOOTER //
// ./src/config/environment.ts